export default __webpack_public_path__ + "static/client02-d9c325ce3e1d001dde31ab73a6735f61.png";